import NavigationBarControl from '../../../lib/ui/NavigationBarControl'
import TextControl from '../../../lib/ui/TextControl'
import PasswordControl from '../../../lib/ui/PasswordControl'

export default class EnterCredentials {
  constructor (element) {
    let fragment = document.createDocumentFragment()
    new NavigationBarControl(fragment, {
      title: 'Uw PRIM account'
    })

    let checkCredentials = () => {
      if (!this.username.getValue() || !this.password.getValue()) {
        alert('Vul uw gebruikersnaam en wachtwoord in.')
        return
      }

      window.PRIM.dataAccess.setCredentials(this.username.getValue(), this.password.getValue())
      window.PRIM.dataAccess.externalStatus().then((status) => {
        switch (status) {
          case 'invalid':
            alert('PRIM account gegevens zijn niet correct. Probeer het opnieuw.')
            break
          case 'exists':
            //alert('PRIM account gegevens zijn correct en zullen voortaan gebruikt worden. Deze kunt u later wijzigen bij instellingen.')
            //window.PRIM.saveCredentials(this.username.getValue(), this.password.getValue())
            window.PRIM.navigate('/sync/')
            break
          default:
            window.PRIM.setLicense(status)            
            //alert('PRIM account gegevens zijn correct en zullen voortaan gebruikt worden. Deze kunt u later wijzigen bij instellingen.')
            //window.PRIM.saveCredentials(this.username.getValue(), this.password.getValue())
            window.PRIM.session.password = this.password.getValue()

            if (window.PRIM.License.isDemo) {
              alert('U logt in met een PRIM demonstratie account. Dit account biedt u de mogelijkheid om PRIM uit te proberen. Er zullen echter geen gegevens worden bewaard. Voer daarom geen gegevens die belangrijk voor u zijn.')
              addEventListener('beforeunload', (e) => {
                e.returnValue = 'U verlaat de demonstratieversie van PRIM. Eventuele ingevoerde gegevens zijn niet opgeslagen. Weet u het zeker?'
                return e.returnValue
              })
            }

            window.PRIM.navigate('/sync/')
            break
        }
      }, (e) => {
        alert('PRIM account gegevens konden niet gecontroleerd worden. De server is tijdelijk niet bereikbaar. Probeer het opnieuw.')
      })
    }

    let div = document.createElement('div')
    div.className = 'viewport'

    let p = document.createElement('p')
    p.innerHTML = 'Om in te loggen, voer hieronder uw PRIM account gegevens in.'

    let fieldset = document.createElement('fieldset')
    let legend = document.createElement('legend')
    legend.innerHTML = 'Account gegevens'
    fieldset.appendChild(legend)

    this.username = new TextControl(fieldset, {label: 'PRIM gebruikersnaam'})
    this.password = new PasswordControl(fieldset, {label: 'PRIM wachtwoord'})

    let button = document.createElement('button')
    button.innerHTML = 'Inloggen'
    button.onclick = checkCredentials

    /*let buttonPrevious = document.createElement('button')
    buttonPrevious.innerHTML = 'Vorige'
    buttonPrevious.onclick = () => {
      window.PRIM.navigate('/welcome/')
    }*/

    div.appendChild(p)
    div.appendChild(fieldset)

    div.appendChild(button)
    //div.appendChild(buttonPrevious)
    fragment.appendChild(div)

    element.appendChild(fragment)
  }
}



// WEBPACK FOOTER //
// ./js/modules/start/action/EnterCredentials.js